module.exports = __webpack_public_path__ + "media/images/icon__point--default@2x-a8ccfaa121af516deb67ebe148c56276.png";